function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "ouh-page"
};
var _hoisted_2 = {
  class: "ouh-header"
};
var _hoisted_3 = {
  class: "ouh-header-content"
};
var _hoisted_4 = {
  class: "ouh-top-row"
};
var _hoisted_5 = {
  class: "ouh-avatar"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 1,
  class: "ouh-avatar-fallback"
};
var _hoisted_8 = {
  class: "ouh-info"
};
var _hoisted_9 = {
  class: "ouh-name"
};
var _hoisted_10 = {
  key: 0,
  class: "ouh-ip"
};
var _hoisted_11 = {
  key: 0,
  class: "ouh-bio"
};
var _hoisted_12 = {
  class: "ouh-stats"
};
var _hoisted_13 = {
  class: "ouh-stat"
};
var _hoisted_14 = {
  class: "ouh-num"
};
var _hoisted_15 = {
  class: "ouh-stat"
};
var _hoisted_16 = {
  class: "ouh-num"
};
var _hoisted_17 = {
  class: "ouh-stat"
};
var _hoisted_18 = {
  class: "ouh-num"
};
var _hoisted_19 = {
  class: "ouh-actions"
};
var _hoisted_20 = {
  class: "ouh-content"
};
var _hoisted_21 = {
  ref: "scrollRef",
  class: "ouh-list-wrapper"
};
var _hoisted_22 = {
  class: "ouh-grid"
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = {
  class: "ouh-cover"
};
var _hoisted_25 = ["src"];
var _hoisted_26 = {
  class: "ouh-play-icon"
};
var _hoisted_27 = {
  class: "ouh-card-title"
};
var _hoisted_28 = {
  class: "ouh-card-footer"
};
var _hoisted_29 = {
  class: "ouh-mini-user"
};
var _hoisted_30 = ["src"];
var _hoisted_31 = {
  key: 1,
  class: "ouh-mini-avatar-fallback"
};
var _hoisted_32 = {
  class: "ouh-mini-name"
};
var _hoisted_33 = {
  class: "ouh-like"
};
var _hoisted_34 = {
  class: "ouh-like-count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_button = _resolveComponent("van-button");
  var _component_van_empty = _resolveComponent("van-empty");
  var _component_van_icon = _resolveComponent("van-icon");
  var _component_van_list = _resolveComponent("van-list");
  var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  var _component_WechatOpenLaunchApp = _resolveComponent("WechatOpenLaunchApp");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "ouh-header-bg",
    style: _normalizeStyle($options.headerBgStyle)
  }, null, 4), _cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "ouh-header-mask"
  }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$options.avatarUrl ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "ouh-avatar-img",
    src: $options.avatarUrl,
    alt: ""
  }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("div", _hoisted_7, "U"))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($options.userName), 1), $options.ipText.trim() ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($options.ipText), 1)) : _createCommentVNode("", true)])]), $options.userBio.trim() ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($options.userBio), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString($options.followerCount), 1), _cache[7] || (_cache[7] = _createElementVNode("span", {
    class: "ouh-label"
  }, "粉丝", -1))]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString($options.followCount), 1), _cache[8] || (_cache[8] = _createElementVNode("span", {
    class: "ouh-label"
  }, "关注", -1))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString($options.likedCount), 1), _cache[9] || (_cache[9] = _createElementVNode("span", {
    class: "ouh-label"
  }, "获赞", -1))])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: "ouh-btn ouh-btn--follow",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onFollowClick && $options.onFollowClick.apply($options, arguments);
    })
  }, _toConsumableArray(_cache[10] || (_cache[10] = [_createElementVNode("span", {
    class: "ouh-plus"
  }, "+", -1), _createElementVNode("span", null, "关注", -1)]))), _createElementVNode("div", {
    class: "ouh-btn ouh-btn--msg",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.onMessageClick && $options.onMessageClick.apply($options, arguments);
    })
  }, "私信")])])]), _createElementVNode("div", _hoisted_20, [_cache[13] || (_cache[13] = _createElementVNode("div", {
    class: "ouh-content-tab"
  }, [_createElementVNode("div", {
    class: "ouh-tab-title"
  }, "作品")], -1)), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_pull_refresh, {
    modelValue: $data.refreshing,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.refreshing = $event;
    }),
    onRefresh: $options.onRefresh
  }, {
    default: _withCtx(function () {
      return [$options.showEmpty ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: $data.error ? '加载失败' : '暂无作品'
      }, {
        default: _withCtx(function () {
          return [$data.error ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            size: "small",
            type: "primary",
            onClick: $options.onRetry
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[12] || (_cache[12] = [_createTextVNode(" 点击重试 ", -1)]));
            }),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["description"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_van_list, {
        ref: "vlistRef",
        loading: $data.loading,
        "onUpdate:loading": _cache[2] || (_cache[2] = function ($event) {
          return $data.loading = $event;
        }),
        error: $data.error,
        "onUpdate:error": _cache[3] || (_cache[3] = function ($event) {
          return $data.error = $event;
        }),
        finished: $data.finished,
        offset: 160,
        "immediate-check": false,
        "finished-text": $options.finishedText,
        "error-text": "加载失败，点击重新加载",
        onLoad: $options.onLoad
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, function (item) {
            var _item$like_count;
            return _openBlock(), _createElementBlock("div", {
              class: "ouh-card",
              key: item.post_id,
              onClick: function onClick($event) {
                return $options.onOpenDetail(item);
              }
            }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
              class: "ouh-cover-img",
              src: $options.getCoverUrl(item),
              alt: ""
            }, null, 8, _hoisted_25), _createElementVNode("div", _hoisted_26, [_createVNode(_component_van_icon, {
              name: "play"
            })])]), _createElementVNode("div", _hoisted_27, _toDisplayString(item.title || item.description || ' '), 1), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [$options.avatarUrl ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "ouh-mini-avatar",
              src: $options.avatarUrl,
              alt: ""
            }, null, 8, _hoisted_30)) : (_openBlock(), _createElementBlock("div", _hoisted_31, "U")), _createElementVNode("div", _hoisted_32, _toDisplayString($options.userName), 1)]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_van_icon, {
              name: "like-o"
            }), _createElementVNode("span", _hoisted_34, _toDisplayString((_item$like_count = item.like_count) !== null && _item$like_count !== void 0 ? _item$like_count : 0), 1)])])], 8, _hoisted_23);
          }), 128))])];
        }),
        _: 1
      }, 8, ["loading", "error", "finished", "finished-text", "onLoad"]), [[_vShow, !$options.showEmpty]])];
    }),
    _: 1
  }, 8, ["modelValue", "onRefresh"])], 512)]), _createElementVNode("div", {
    class: "ouh-bottom-cta",
    onClick: _cache[6] || (_cache[6] = _withModifiers(function () {}, ["stop"]))
  }, [_ctx.shouldUseWechatOpenLaunchTag ? (_openBlock(), _createBlock(_component_WechatOpenLaunchApp, {
    key: 0,
    "app-id": _ctx.wechatOpenLaunchAppId,
    extinfo: _ctx.wxUserHomeLaunchExtinfo,
    "button-text": "App内打开",
    variant: "pill"
  }, null, 8, ["app-id", "extinfo"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "ouh-open-btn",
    onClick: _cache[5] || (_cache[5] = function () {
      return _ctx.onOpenUserHomeInApp && _ctx.onOpenUserHomeInApp.apply(_ctx, arguments);
    })
  }, "App内打开"))])]);
}